import { memo } from 'react'
import { isEqual } from 'lodash'
import ProfileContainer from 'app/containers/Profile'
import { PageTitle } from 'app/components/common/PageTitle'
import { useTranslation } from 'react-i18next'
import R from 'app/assets/R'

const ProfileCpn = () => {
  const { t } = useTranslation()
  return (
    <>
      <PageTitle>{t(R.strings.profile)}</PageTitle>
      <ProfileContainer />
    </>
  )
}
export const ProfilePage = memo(ProfileCpn, isEqual)
